module.exports = __webpack_public_path__ + "static/img/require02.712d491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head/require02.jpg
// module id = 47Qp
// module chunks = 8